<script>
import Gen from '@helper/Gen'
import "./plugins/css/bootstrap-tagsinput.css"
import "./plugins/dist/bootstrap-tagsinput.min.js"

export default {
  props: ['name','value','validate'],
  mounted: function () {
    $(this.$el).val(this.value).tagsinput()
    $(this.$el).change((e) => {
      this.$emit('input', e.target.value)
      this.onEdit = true
      Gen.delay(() => {
        this.onEdit = false
        $(this.$el).valid()
      }, 300)
    })
  },
  watch: {
    value: function (v) {
      if (this.onEdit) return;
      $(this.$el).tagsinput('removeAll')
      $(this.$el).tagsinput('add', v)
    }
  },
}
</script>

<template>
  <input :name="name" type="text">
</template>
